export default {
  'Nps.points': 'Nps очки',
}
